import batchEditComponent from './batch.edit.component';

let batchEditModule = angular.module('batchedit', [
])

.component('batchedit', batchEditComponent)

.name;

export default batchEditModule;


// WEBPACK FOOTER //
// ./client/app/components/batch/edit/index.js